import Api from "../axios";

export default async function apiAddHoliday({ holidayDate, holidaySubject }) {
  // console.log("holidayDate, holidaySubject", holidayDate, holidaySubject);
  return await Api.post("/add_holiday", {
    date: holidayDate,
    subject: holidaySubject,
  });
}
